import { PlaylistStorageService } from "./PlaylistStorageService";
import { bindPlaylistsToStore as bind, syncPlaylistsToStore as sync } from "./storeBinding";

// The one instance the app uses. Components and services import this, never localStorage, for playlists.
const PlaylistStorage = new PlaylistStorageService();

export default PlaylistStorage;

export const bindPlaylistsToStore = () => bind(PlaylistStorage);
export const syncPlaylistsToStore = () => sync(PlaylistStorage);

export { PlaylistStorageService } from "./PlaylistStorageService";
export { playlistErrorMessage } from "./errors";
